import { LeadForm } from "@2u-landing-pages/components";
import React from "react";
import styles from "./Section10.module.scss";

export const Section10 = React.forwardRef((props, ref) => {
  return (
    <section id="multi-step-form" ref={ref} className={`${styles.container} cc--component-container rv-lead-form`}>
      <div className={styles.form}>
        <LeadForm packageId="2985" enableStyles={false} />
      </div>
    </section>
  );
});

Section10.displayName = "Section10";
